import React from 'react';
import { useAppTheme } from '@/context/ThemeContext';
import DevCharitySidebar from './DevCharitySidebar';
import Header from '../layout/Header';
import { useState, useEffect } from 'react';

type DevLayoutCharityProps = {
  children: React.ReactNode;
  title: string;
};

const DevLayoutCharity: React.FC<DevLayoutCharityProps> = ({ children }) => {
  const { theme, themeConfig, setTheme } = useAppTheme();
  const [isMinimized, setIsMinimized] = useState(localStorage.getItem('sidebarMinimized') === 'true');
  
  // Save sidebar state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebarMinimized', isMinimized.toString());
  }, [isMinimized]);
  
  const toggleSidebar = () => {
    setIsMinimized(!isMinimized);
  };
  
  const toggleTheme = () => {
    const newTheme = theme === 'charity' ? 'business' : 'charity';
    setTheme(newTheme);
  };
  
  // Sidebar width calculation
  const SIDEBAR_EXPANDED_WIDTH = 240;
  const SIDEBAR_MINIMIZED_WIDTH = 64;
  const sidebarWidth = isMinimized ? SIDEBAR_MINIMIZED_WIDTH : SIDEBAR_EXPANDED_WIDTH;

  return (
    <div className="flex h-full w-full overflow-hidden min-w-[1024px]" style={{ backgroundColor: themeConfig.surface }}>
      {/* Charity Sidebar positioned at the far left */}
      <DevCharitySidebar 
        isOpen={true} 
        isMinimized={isMinimized} 
        onClose={() => {}} 
        theme={theme}
      />
      
      {/* Main Content */}
      <div className="flex flex-col flex-1 w-full h-full transition-all duration-300 ease-in-out">
        <Header 
          title={``} 
          onMenuClick={toggleSidebar}
          onThemeToggle={toggleTheme}
          isMinimized={isMinimized}
        />
        
        {/* Main Content Area */}
        <main 
          className="flex-1 w-full h-full overflow-auto" 
          style={{ 
            backgroundColor: themeConfig.surface, 
          }}
        >
          <div 
            className="w-full py-4 mx-auto"
            style={{ 
              paddingLeft: `calc(${sidebarWidth}px + 20px)`, 
              paddingRight: '20px' 
            }}
          >
            {/* Development Environment Banner */}
            <div 
              className="p-4 rounded-lg mb-6"
              style={{ 
                backgroundColor: themeConfig.warning,
                color: themeConfig.text
              }}
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium">Development Environment - Charity Portal</h3>
                  <div className="mt-2 text-sm">
                    <p>This is a development environment with owner access. Data shown here is for testing purposes only.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Page Content */}
            <div className="pb-4">
              {children}
            </div>
          </div>
        </main>
        
        {/* Footer */}
        <footer className="w-full bg-white shadow-md py-3 px-4 text-center text-sm text-gray-600">
          <p>© {new Date().getFullYear()} Catch of the Day. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default DevLayoutCharity;
